import { Injectable } from "@angular/core";
import { RequestBase } from "./request-base";
import { HttpClient, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class IntegrationService extends RequestBase {
    BasePath = 'api/integration';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    FileExists(fileName): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + '/FileExists?fileName=' + fileName, this.options);
    }

    UploadFile(fileData): Observable<any> {
        const req = new HttpRequest('POST', this.API_BASE_URL + this.BasePath + '/UploadFile', fileData);
        return this.http.request(req);
    }

    GetFileStructure(query): Observable<any> {
        return this.http.post<any>(this.API_BASE_URL + this.BasePath + '/GetFileStructure', query, this.options);
    }

    GetExportTables(datasource): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + '/GetExportTables?datasource=' + datasource, this.options);
    }

    ExecuteImport(description): Observable<any> {
        return this.http.post<any>(this.API_BASE_URL + this.BasePath + '/ExecuteImport', description, this.options);
    }
}

